import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {SabrSummary} from '../sabr/sabr-summary';
import {GoogleService} from './google-service';

@Service()
export class SabrService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getSabrSummary(folderNumber: string, entityId: string, customerId: string): Observable<SabrSummary> {
    let url = this.urlBase + 'sabrSummary/' + folderNumber + '/' + entityId + '/' + customerId;
    return this.http.get<SabrSummary>(url, {headers: this.getRequestHeaders()});
  }

  public downloadInvoiceDocument(company: string, invoiceNumber: number): Observable<Blob> {
    let url = this.urlBase + 'sabrSummary/invoice/pdf/' + company + '/' + invoiceNumber;
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => {
      return new Blob([response.body], {type: response.headers.get('Content-Type')});
    }));
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
